<template>
    <div class="add-fork-truck-dialog">
        <el-dialog
        top="4%"
        style="min-width: 1200px;"
        :close-on-click-modal="closeOnClickModal"
        :title="title"
        :visible.sync="openAddForkTruckDialog"
        :before-close="closeDialog"
        >
        <div class="sec-head">
            <span class="sec-title">基础信息</span>
            <a href="javascript:;" @click="privilegeUpdate" v-if="showPrivilegeBtn" v-has="'04000096'">特权修改</a>
        </div>
        <div class="form-section">
            <el-form inline ref="form" :model="form" :rules="rules" label-width="110px" size="mini" style="font-size: 14px;">
                <el-form-item label="叉车序号：">
                    <el-input v-model.trim="form.serialNum" disabled></el-input>
                </el-form-item>
                <el-form-item label="叉车编号：" :prop="form.newFlag ? '' : 'forkliftCode'">
                    <el-input v-model.trim="form.forkliftCode" placeholder="请输入叉车编号" @input="forkliftCodeInput" :disabled="isDisabled" maxlength="20"></el-input>
                </el-form-item>
                <el-form-item label="出厂时间：" prop="deliveryDate">
                    <el-date-picker
                        value-format="yyyy-MM-dd"
                        v-model="form.deliveryDate"
                        type="date"
                        class="time-type"
                        placeholder="请选择出厂时间"
                        :disabled="isDisabled"
                        style="width: 160px"
                    ></el-date-picker>
                </el-form-item>
                <el-form-item label="叉车状态：" prop="enableFlag">
                    <el-select v-model="form.enableFlag" :disabled="isDisabled" style="width: 160px">
                        <el-option label="启用" :value="0"></el-option>
                        <el-option label="停用" :value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="设备类型：" prop="deviceType">
                    <m-select ref="deviceType" :optionNum="'SRM_DEVICE_TYPE_NAME'" :value="form.deviceType" :filterable="true" @input="setValue($event, 'deviceType')"
                    :disabled="isDisabled" style="width: 160px"></m-select>
                </el-form-item>
                <el-form-item label="设备品牌：" prop="deviceBrand">
                    <m-select ref="deviceBrand" :optionNum="'SRM_EQUIPMENT_BRAND'" :value="form.deviceBrand" :filterable="true" @input="setValue($event, 'deviceBrand')"
                    :disabled="isDisabled" style="width: 160px"></m-select>
                </el-form-item>
                <el-form-item label="型号：" prop="model">
                    <el-input v-model.trim="form.model" maxlength="25" :disabled="isDisabled" placeholder="请输入型号"></el-input>
                </el-form-item>
                <el-form-item label="核载重量/T：" prop="payload">
                    <el-input v-model.trim="form.payload" @input="payloadInput" :disabled="isDisabled" placeholder="请输入核载重量/T"></el-input>
                </el-form-item>
            </el-form>
        </div>
        <div class="isNewCar">
            <el-checkbox v-model="form.newFlag">是否为新车</el-checkbox>
        </div>
        <div class="sec-head">
            <span class="sec-title">叉车附件</span>
            <div>
                <!-- <el-button class="certificate-temp-btn" type="text" @click="handleTempDownload">下载模板</el-button> -->
                <upload uploadDisplayType="text" text="上传附件" @uploadSuccess="callback"></upload>
            </div>
        </div>
        <div class="file-section">
            <el-table :data="certificateData" border style="width: 100%">
                <el-table-column prop="fileName" label="附件名称" width="400" align="center" show-overflow-tooltip></el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" class="preview-btn" @click="preview(scope.row)">预览</el-button>
                        <el-button @click="handleRemove(scope.row)" type="text" size="small">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="dialog-footer-btns">
            <el-button @click="closeDialog">取消</el-button>
            <el-button type="primary" @click="submitForm('form')">提交</el-button>
        </div>
        </el-dialog>
        <preview
            v-if='attachmentShow'
            :attachmentShow.sync='attachmentShow'
            :rowData='rowData'>
        </preview>
    </div>
</template>
<script>
import mSelect from '../../../../../../components/Select.vue';
import upload from '../../../../../../components/upload/Index';
import preview from '../../../../../../components/AttachmentDialog';
import { saveForkTruckInfo, editForkTruckInfo, getForkTruckInfoDetail } from '../../../../../../api/forkTruck';
import addOrEditFormRule from './addOrEditFormRule';
import config from './config';
export default {
    components: { mSelect, upload, preview },
    props: {
        title: { type: String, default: '' },
        openAddForkTruckDialog: { type: Boolean, default: false },
        relationId: { type: [Number, String], required: true }
    },
    data() {
        return {
            closeOnClickModal: false,
            form: config.formData,
            rules: addOrEditFormRule,
            attachmentShow: false,
            certificateData: [],
            supplierCode: '',
            isDisabled: false,
            newForkliftCode: '' // 新的叉车编号
        };
    },
    computed: {
        visible() { // 叉车状态为停用时，可勾选对应的附件进行删除文档
            return this.form.contractStatus === 1;
        },
        showPrivilegeBtn() {
            return this.form.enableFlag === 0;
        }
    },
    watch: {
        'form.newFlag'() { // 如果[是否为新车]有变化，清除叉车编号字段报错信息
            return this.$refs['form'].clearValidate('forkliftCode');
        }
    },
    mounted() {
        const isSupplier = !!this.$store.state.supplier; // 是否是供应商平台端
        this.supplierCode = isSupplier ? this.$store.state.supplier.supplierCode : this.$route.query.supplierCode;
        if (this.relationId) { // 获取编辑数据
            this.getForkTruckInfoDetail(this.relationId);
        }
    },
    methods: {
        forkliftCodeInput(val) {
            this.form.forkliftCode = this.form.forkliftCode.replace(/[\W]/g, ''); // 叉车编码只允许数字或字母
        },
        closeDialog() {
            this.resetForm();
            this.$emit('update:openAddForkTruckDialog', false);
        },
        resetForm() { // 重置表单
            this.$refs.form.resetFields();
            this.form.serialNum = '';
            this.form.forkliftCode = '';
            this.form.newFlag = false;
            this.certificateData = [];
            this.$parent.relationId = '';
            this.form.id = '';
            this.form.relationId = '';
            this.newForkliftCode = '';
        },
        getForkTruckInfoDetail(relationId) { // 获取
            getForkTruckInfoDetail(relationId).then(res => {
                if (res && +res.code === 0) {
                    const { id, relationId, serialNum, forkliftCode, deliveryDate, enableFlag, deviceType, deviceBrand, model, payload, newFlag } = res.data;
                    this.form.id = id;
                    this.form.relationId = relationId;
                    this.form.serialNum = serialNum;
                    this.form.forkliftCode = forkliftCode;
                    this.form.deliveryDate = deliveryDate;
                    this.form.enableFlag = enableFlag;
                    this.form.deviceType = deviceType;
                    this.form.deviceBrand = deviceBrand;
                    this.form.model = model;
                    this.form.payload = payload;
                    this.form.newFlag = !newFlag;
                    this.certificateData = res.data.fileList || [];
                    this.newForkliftCode = forkliftCode;
                    this.isDisabled = this.form.enableFlag === 0; // 停用状态下可以修改，但没有特权修改按钮，启用状态下不可以修改，但有特权修改按钮，这个特权修改按钮是受权限控制
                }
            });
        },
        setValue(data, key) {
            this.$set(this.form, key, data);
        },
        payloadInput() {
            if (this.form.payload) { // 只能输入数字类型，并且保留两位小数
                this.form.payload = this.form.payload.replace(/[^\d.]/g, '').replace(/^\./g, '').replace(/\.{2,}/g, '.');
                this.form.payload = this.form.payload.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
                this.form.payload = this.form.payload.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3');
            }
        },
        callback(data) { // 附件上传成功后的回调
            if (data.data.code === '0') {
                this.$message.success('上传成功');
                this.certificateData.push({
                    fileId: data.data.data.id,
                    fileName: data.data.data.localFileName,
                    fileUrl: data.data.data.downUrl,
                    fileData: data.data.data
                });
            }
        },
        preview(row) { // 预览附件
            this.rowData = row;
            this.rowData.downUrl = row.fileUrl;
            this.attachmentShow = true;
        },
        handleRemove(row) { // 删除附件
            if (this.form.enableFlag === 1) { // 停用状态才可删除附件
                this.certificateData.forEach((item, index) => {
                    if (item.fileId === row.fileId) {
                        this.certificateData.splice(index, 1);
                    }
                });
            } else {
                this.$message.warning('叉车状态启用时不可删除');
            }
        },
        handleTempDownload() {},
        privilegeUpdate() {
            this.isDisabled = false;
        },
        submitForm(formName) { // 提交
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    setTimeout(() => this.$refs[formName].clearValidate(), 3000);
                    return false;
                }
                if (this.form.newFlag && this.certificateData.length === 0) { // 如果是否为新车勾选，附件必须上传
                    this.$message.warning('请上传附件');
                    return false;
                }
                const formData = JSON.parse(JSON.stringify(this.form));
                formData['newFlag'] = formData['newFlag'] ? 0 : 1;
                formData['payload'] = +formData['payload'];
                formData['supplierCode'] = this.supplierCode;
                formData['fileList'] = this.certificateData;
                if (this.relationId) { // 编辑
                    if (formData['enableFlag'] === 0 && (this.newForkliftCode !== formData.forkliftCode)) { // 如果启用状态下叉车编码发生改变，提示[确认保存后不可变更叉车编码，请确认]
                        this.$confirm('确认保存后不可变更叉车编码，请确认', {
                            confirmButtonText: '确认',
                            cancelButtonText: '取消'
                        }).then(() => {
                            this.saveFormData(formData);
                        }).catch(() => {});
                        return;
                    }
                    this.saveFormData(formData);
                } else { // 新增
                    saveForkTruckInfo(formData).then(res => {
                        if (res && +res.code === 0) {
                            this.$emit('success');
                            this.$message.success('保存成功');
                            this.closeDialog();
                        }
                    });
                }
            });
        },
        saveFormData(params) {
            editForkTruckInfo(params).then(res => {
                if (res && +res.code === 0) {
                    this.$emit('success');
                    this.$message.success('保存成功');
                    this.closeDialog();
                }
            });
        }
    }
};
</script>
<style scoped lang="less">
.add-fork-truck-dialog {
    .sec-head { border-bottom: 1px solid #ddd; padding-bottom: 16px; font-size: 14px; display: flex; justify-content: space-between; align-items: center; }
    .sec-head > a { color: #00BCBF; margin-left: 40px; }
    .sec-head > a:hover { text-decoration: underline; }
    .form-section { padding: 16px 0; }
    .isNewCar { margin-bottom: 16px; }
    .file-section { padding: 16px 0; }
    .file-btns { margin-bottom: 16px; }
    .file-btns > a { color: #00BCBF; margin-right: 15px;
        & > i { display: inline-block; margin-right: 3px; }
    }
    .dialog-footer-btns { margin: 20px 0 10px; text-align: right; }
    .register-upload { font-size: 12px; color: #00a9ac; display: inline-block; margin-left: 20px; }
}
</style>